import { useCallback, useEffect, useState } from 'react';
import { GetAdminProspectsAPI } from '../../../../api/AdminAPI';

/**
 * useProspects
 *
 * Catálogo da Prospecção (admin/prospects/list.php) com filtros. view "today" traz só a
 * fila do dia (today_group em cada item) e quantas mensagens já saíram hoje (sentToday,
 * para a cota do dia; bumpSentToday soma os envios feitos sem recarregar).
 * upsert troca ou acrescenta um contato sem recarregar a lista.
 *
 * @param {{ q: string, category: string, status: string, source?: string, view?: string }} filters
 * @returns {{ items: Array, isLoading: boolean, error: string|null, sentToday: number, refresh: Function, upsert: Function, bumpSentToday: Function }}
 */
function useProspects(filters) {
  const [items, setItems] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [sentToday, setSentToday] = useState(0);

  const { q, category, status, source, view = '' } = filters;

  const refresh = useCallback(() => {
    setIsLoading(true);
    setError(null);
    GetAdminProspectsAPI({ q, category, status, source, view }, (response) => {
      if (!response || response.success === false) {
        setError(response?.error || 'Erro ao carregar os contatos. Tente novamente.');
        setIsLoading(false);
        return;
      }
      setItems(response.items || []);
      setSentToday(Number(response.sent_today) || 0);
      setIsLoading(false);
    });
  }, [q, category, status, source, view]);

  useEffect(() => {
    const timer = setTimeout(refresh, 300);
    return () => clearTimeout(timer);
  }, [refresh]);

  const upsert = useCallback((item) => {
    if (!item) return;
    setItems((prev) => {
      const exists = prev.some((row) => row.id === item.id);
      return exists ? prev.map((row) => (row.id === item.id ? item : row)) : [item, ...prev];
    });
  }, []);

  const bumpSentToday = useCallback((count = 1) => setSentToday((prev) => prev + count), []);

  return { items, isLoading, error, sentToday, refresh, upsert, bumpSentToday };
}

export default useProspects;
